<template>
  <!--
          作者：luoyiming
          时间：2019-10-24
          描述：统计-会员统计
      -->
  <div>
    <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline" v-if="homeshow">
      <el-form-item label="推广账号">
        <el-select size="small" v-model="searchForm.tuiguang_id" placeholder="请选择">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="(item, index) in shlist" :key="index" :label="item.user_name"
            :value="item.shop_user_id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item><el-button size="small" type="primary" icon="el-icon-search"
          @click="onSubmit">查询</el-button></el-form-item>
    </el-form>

    <div class="statistics-member" v-loading="loading" style="min-height: 240px;">
      <div class="common-form">会员统计</div>
      <div class="d-s-stretch bd-box">
        <div class="d-s-c d-c left-box">
          <div class="d-a-c lh30 ww100 pt16">
            <div class="pt30 tc" style="width: 80px;">
              <p class="gray9">今日</p>
              <p class="gray9">昨日</p>
            </div>
            <div class="flex-1 tc">
              <p>累积会员数</p>
              <p class="f20 fb gray3">{{ dataModel.user.user_total.today }}</p>
              <p class="gray">{{ dataModel.user.user_total.yesterday }}</p>
            </div>
            <div class="flex-1 tc">
              <p>新增会员数</p>
              <p class="f20 fb gray3">{{ dataModel.user.user_add.today }}</p>
              <p class="gray">{{ dataModel.user.user_add.yesterday }}</p>
            </div>
            <div class="flex-1 tc">
              <p>成交会员数</p>
              <p class="f20 fb gray3">{{ dataModel.user.user_pay.today }}</p>
              <p class="gray">{{ dataModel.user.user_pay.yesterday }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--新增会员-->
    <LineChart v-if="!loading"></LineChart>


    <!-- <div class="d-b-c" style="margin-bottom: 15px;">
          <div>
            <el-date-picker size="small" v-model="datePicker" type="daterange" align="right" unlink-panels
              format="yyyy-MM-dd" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" @change="changeDate" :picker-options="pickerOptions"></el-date-picker>
          </div>
      </div> -->



    <!-- <div class="common-form">交易统计</div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="订单数" name="order"></el-tab-pane>
      <el-tab-pane label="退款数" name="refund"></el-tab-pane>
    </el-tabs>


    <div>
      <div class="Echarts"><div id="TransactionChart"></div></div>
    </div> -->


  </div>
</template>

<script>
import AuthApi from '@/api/auth.js';
import StatisticsApi from '@/api/statistics.js';
import OrderApi from "@/api/order.js";
import Total from './part2/Total.vue';
import LineChart from './part2/LineChart.vue';
import Pie from './part2/Pie.vue';
import Ranking from './part2/Ranking.vue';
import { formatDate } from '@/utils/DateTime.js'
export default {
  components: {
    Total,
    LineChart,
    Pie,
    Ranking
  },
  data() {
    let endDate = new Date();
    let startDate = new Date();
    startDate.setTime(startDate.getTime() - 3600 * 1000 * 24 * 7);
    return {
      homeshow:true,
      roleList:"",
      searchForm: {
        tuiguang_id: "",
      },
      /*选择商户*/
      shlist: [],
      /*是否正在加载*/
      loading: true,
      /*数据对象*/
      dataModel: {},
      /*时间快捷选项*/
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      datePicker: [formatDate(startDate, 'yyyy-MM-dd'), formatDate(endDate, 'yyyy-MM-dd')],
    }
  },
  // provide: function () {
  //   return {
  //     dataModel: this.dataModel
  //   }
  // },
  created() {
    this.getData();
    this.getTableList();
    this.gofenpei();
  },
  inject: ['baseInfo'],
  methods: {

     /*获取列表*/
     getTableList() {
      let self = this;
      let Params = {};
      AuthApi.userList(Params, true)
        .then(data => {
          self.roleList = data.data.list.data;
          // console.log("roleList",self.roleList);
          // console.log("baseInfo",self.baseInfo.user.user_name);
          let datainfo = self.roleList;
          for (let item of datainfo) {
            // console.log(item.user_name);
            if (item.user_name == self.baseInfo.user.user_name) {
              // console.log(item.role_id);
              if(item.role_id == 4){
                  self.homeshow = false;
              }else{
                self.homeshow = true
              }
            }
          }
        })
        .catch(error => {});
    },

    onSubmit() {
      this.getData();
    },

    /*选择时间*/
    changeDate() {
      console.log(this.datePicker);
      this.getData();
    },

    gofenpei() {
      OrderApi.authuser({
        role_id: 4
      }, true).then(data => {
        this.shlist = data.data.list.data;
      })
    },

    /*获取数据*/
    getData() {
      let self = this;
      // console.log(self.baseInfo.user.user_name);
      // if(self.baseInfo.user.user_name == "tuiguang"){
      //   self.searchForm.tuiguang_id = 10013;
      // }else if(self.baseInfo.user.user_name == "tuiguang2"){
      //   self.searchForm.tuiguang_id = 10015;
      // }
      // day: self.datePicker,
      var param = {};
      if(this.baseInfo.user.shop_user_id == 10001|| this.baseInfo.user.shop_user_id == 10009 || this.baseInfo.user.shop_user_id ==  10010){
        param.tuiguang_id = self.searchForm.tuiguang_id;
      }

      StatisticsApi.getUserTotal2(param, true)
        .then(res => {
          console.log(res.data);
          // Object.assign(self.dataModel, res.data);
          self.dataModel = res.data;
          self.loading = false;
        })
        .catch(error => { });
    }

  }
};
</script>

<style scoped="scoped">
.statistics-member .bd-box {
  border-top: 1px solid #EEEEEE;
}

.statistics-member .left-box {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/statistics/user/tgindex.vue